const blockPartial = require('sma.admin/partials/block.mustache');

let block = function(elem, msg) {
	msg = msg || '';

	let $blockedElement = $(blockPartial({msg: msg}));
	elem.addClass('blocked-element').prepend($blockedElement);

	$blockedElement.css("width", elem.width() + 'px');
	$blockedElement.css("height", elem.height() + 'px');
	elem.css("pointer-events", "none");
}

let unblock = function(elem) {
	elem.find('.form-block').remove();
	elem.removeClass('blocked-element');
	elem.css("pointer-events", "auto");
}

module.exports = {
	block: block,
	unblock: unblock
};


// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/block.js